import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SupportCTA from './components/SupportCTA';
import Footer from './components/Footer';
import GuideSection from './components/GuideSection';

export default function App() {
  // Enforce background colors, gradients, and base text colors directly on the main wrapper to prevent external CSS overrides
  return (
    <div 
      className="min-h-screen w-full selection:bg-purple selection:text-white overflow-x-hidden text-white font-space antialiased bg-navy-page"
      style={{
        backgroundColor: '#0D1B3E',
        backgroundImage: 'radial-gradient(circle at center, #0D1B3E 0%, #0A1628 100%)',
        backgroundAttachment: 'fixed'
      }}
    >
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 md:pt-32 pb-16 md:pb-24 relative z-10">
        <Hero />
        <GuideSection />
      </main>
      <SupportCTA />
      <Footer />
    </div>
  );
}